<template>
  <div class="pcBatteryHolder">
    <Goback :title="'返回站点'" style="position: absolute;left: 20%;top:0;z-index: 10;"></Goback>
    <batteryHolder  :batteryList="batteryList" :vehicleClassification="vehicleClassification"/>
    <Overview class="pcbatteryHolderL" :batteryInfo="batteryInfo"/>
    <div class="flex flex-direction pcbatteryHolderR">
      <SiteType :batteryInfo="batteryInfo"/>
    </div>
  </div>
</template>

<script>
//综合态势
import Goback from "@/components/goBack.vue";
import Overview from "@/views/pcbatteryHolder/overview.vue";
import batteryHolder from "@/views/batteryHolder/batteryHolder";
import SiteType from "@/views/pcbatteryHolder/siteType.vue";
import { dataInterface } from '@/api/dataInterfaceApi';

export default {
  data () {
    return {
      batteryList:[],//电池列表
      batteryInfo:{},//电池仓信息
      vehicleClassification:"",
    };
  },
  components: {
    Overview,
    batteryHolder,
    SiteType,
    Goback
  },
  props: {
    // battery: {
    //   type: Object,
    //   default: () => ({})
    // },
  },
  watch: {
    
  },
  methods: {
    getData(data){
      this.selectBatteryList(data);
      this.chongdiancangleixing(data);
      this.selectBatteryCompartmentInfo(data)
    },
    selectBatteryList(data={}){
      let _this = this;
      dataInterface
        .dataFaceApi({
          'enCode':'chongdiancang-TiDB',
          '@station_id':data.stationId,
        })
        .then((res) => {
          if(!res) return;
          _this.batteryList = res.map(item =>{
            return {
              ...item,
              temperature:item.temperature>60?false:true
            }
          })
          console.log("充电仓",_this.batteryList)
        })
        .catch((err) => {
          console.log(err);
        });
    },
    //乘用车判断
    chongdiancangleixing(data={}){
      let _this = this;
      dataInterface
        .dataFaceApi({
          'enCode':'TiDB-congdiancang-congdiancanglibiaoleixing',
          '@station_id':data.stationId,
        })
        .then((res) => {
          if(!res) return;
          _this.vehicleClassification = res&&res[0]&&res[0].stationType
        })
        .catch((err) => {
          console.log(err);
        });
    },
    //充电仓id
    selectBatteryCompartmentInfo(data={}){
      let _this = this;
      dataInterface
        .dataFaceApi({
          'enCode':'TiDB-congdiancang-congdiancangxinxi',
          '@station_id':data.stationId,
          '@battery_id':data.batteryId,
        })
        .then((res) => {
          if(!res) return;
          console.log("充电仓信息",res)
          _this.batteryInfo = res[0];
        })
        .catch((err) => {
          console.log(err);
        });
    },
  }
}
</script>

<style lang="scss" scoped>
.container {
  display: flex;
}
.pcBatteryHolder{
  .border-box-content{
    display:flex!important;
  }
  .operaBox{
    width:100%!important;
  }
}
</style>